import { render, staticRenderFns } from "./NotEnoughMoney.vue?vue&type=template&id=417f28e0&"
import script from "./NotEnoughMoney.vue?vue&type=script&lang=js&"
export * from "./NotEnoughMoney.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports